import Keycloak from "keycloak-js";

const publicUrl = import.meta.env.VITE_PUBLIC_URL ?? window.location.origin;

export const keycloak = new Keycloak({
  url: `${publicUrl}/auth`,
  realm: import.meta.env.VITE_KEYCLOAK_REALM ?? "agrisense",
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? "agrisense-web",
});

export interface CurrentUser {
  sub: string;
  username: string;
  email?: string | null;
  name?: string | null;
  roles: string[];
  permissions: string[];
  municipalities?: string[];
  bpg?: string[];
  assignments?: string[];
  scoped_permissions?: Record<string, string[]>;
}

/**
 * Inicijalizacija (PKCE). `check-sso`: neprijavljeni korisnik vidi javnu statistiku (bez ličnih podataka) i može se
 * prijaviti ili registrovati; prijavljeni dobija aplikaciju prema svojim ovlašćenjima. Token se osvježava automatski.
 */
export async function initAuth(): Promise<boolean> {
  const ok = await keycloak.init({
    onLoad: "check-sso",
    silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
    pkceMethod: "S256",
    checkLoginIframe: false,
    responseMode: "query",
  });
  if (ok) {
    setInterval(() => {
      keycloak.updateToken(60).catch(() => login());
    }, 20_000);
  }
  return ok;
}

// stranice prijave i registracije uvijek na srpskom (ne prema jeziku pregledača)
export const login = () => keycloak.login({ locale: "sr" });
export const register = () => keycloak.register({ locale: "sr" });

export async function getToken(): Promise<string | undefined> {
  if (!keycloak.authenticated) return undefined;
  try {
    await keycloak.updateToken(30);
  } catch {
    await login();
  }
  return keycloak.token;
}

export function logout() {
  return keycloak.logout({ redirectUri: window.location.origin });
}
